// src/utils/httpCancel.js
// True when an axios request was cancelled via AbortController — callers use
// this to skip error handling/state updates for intentionally-aborted requests.
export function isAbortError(err) {
  return err?.code === 'ERR_CANCELED' || err?.name === 'CanceledError';
}
